FeedsApp.Views.FeedBuilderStep6 = Backbone.View.extend({

	className: "row",

	events: {
		"click .add-schedule": "addSchedule"
	},

    updateMasterModel: function() {
		// not implemented yet
	},

	initialize: function() {
		var self = this;

		$.ajax({
			url: '/assets/js/feeds/feed-builder/templates/step6.html',
			success: function (extTemplate) {
				self.template = _.template(extTemplate);
				self.render();

				//listen for exclude_timsetamp to change. if it changes, run renderExcludeTimestampWarning
				self.listenTo(self.model, 'change:exclude_timestamp', self.renderExcludeTimestampWarning);
				self.listenTo(self.model.get('feed_schedules'), 'add remove reset scheduleFrequencyChanged', self.renderExcludeTimestampWarning);

				$.ajax({
					url: '/assets/js/feeds/feed-builder/templates/schedule-template.html',
					success: function (extTemplate) {
						FeedsApp.Templates.ScheduleTemplate = _.template(extTemplate);
						self.model.get('feed_schedules').each(function (schedule) {
							new FeedsApp.Views.ScheduleView({model: schedule});
						})
					},
					dataType: 'html',
					cache: true
				});
			},
			dataType: 'html',
			cache: true
		});
	},

	render: function() {
		if(!this.template) return; //template not loaded yet
		this.$el.html(this.template(this.model.toJSON()));

		if(!this.$el.parent().length) {
			$('#step6').append(this.$el);
		}
	},

	addSchedule: function() {
		var scheduledFeed = new FeedsApp.Models.ScheduledFeeds();
        this.model.get('feed_schedules').add(scheduledFeed);
		new FeedsApp.Views.ScheduleView({ model: scheduledFeed });
	},

	// If exclude_timestamp is true AND the user has selected a schedule to run the feed
	// multiple times per day, then a warning will show that this could
	// cause new feed files to overwrite old files from earlier in the day
	renderExcludeTimestampWarning: function() {
		var show = false;
		var excludeTimestamp = this.model.get('exclude_timestamp');

		var schedules = this.model.get('feed_schedules');
		var intervalSchedule = false;
		for (const schedule of schedules.models) {
			if(schedule.get('frequency') === 'interval') {
				intervalSchedule = true;
				break;
			}
		}

		// show a warning to the user if these conditions are met
		if(excludeTimestamp === true && intervalSchedule === true) show = true;

		this.$('.exclude-timestamp-warning').toggle(show);
	},
});